import React, { Component } from "react";
import Helpers from "../../helpers/shared.helper";
import Storage from "../../services/storage.service";
import Payments from "../../services/payments.service";
import GTMService from "../../services/gtm.service";
import SpinnerTimeLoader from "../shared/timeLoading";
import TopUpSuccess from "./top-up-success";
import TopUpFailed from "./top-up-failed";

export default class ConfirmationTopupTAP extends Component {

	params = {};
	state = {
		loading: true,
		success: false,
		failed: false,
		error: false
	};

	componentDidMount() {
		if (window) {
			Helpers.log(window.location);
			Storage.clear("paymentFailedError");		
            if (localStorage.getItem("order_id") && localStorage.getItem("status")) {
                let order_id = null;
                let status = null;
                
                let order_id_obj = JSON.parse(localStorage.getItem("order_id"));
                let status_obj = JSON.parse(localStorage.getItem("status"));
                
                order_id = order_id_obj[Storage.get("session")];
                status = status_obj[Storage.get("session")];
    
                let data = {
                    order_id: order_id,
                    status_id: status,
                };

                Helpers.log("order_id = " + order_id);
                Helpers.log("Before verifyTAPResponse data: ", data);
                Storage.set("paymentFailedError", true, true);

                if(order_id && status) {
                    Payments.topupVerifyPayfortResponse(data)
                        .then(response => {
                            Storage.set("paymentFailedError", true, true);
                            Helpers.log("topupVerifyTAPResponse: ", response);
                            Storage.clear("paymentFailedError");
                            if (response.status === 201) {
                                this.setState({
                                    success: true
                                });
                            } else {
                                this.setState({
                                    failed: true
                                })
                            }
                        })
                        .catch(error => {
                            Helpers.log("verifyTAPResponse catch: ", error);
                            // Errors.handleError(error);
                            Payments.actionOnPaymentFail();

                            let fgplan = JSON.parse(localStorage.getItem("is_broadband_plan_selected"));
                            if (!fgplan) {
                                GTMService.action_on_payment_failed();
                            }
                            this.setState({
                                failed: true
                            })
                        });
                }
            } else {
                // no order id found
                Helpers.log("no order id found");
                Payments.actionOnPaymentFail();
                let fgplan = JSON.parse(localStorage.getItem("is_broadband_plan_selected"));
                if (!fgplan) {
                    GTMService.action_on_payment_failed();
                }
                this.setState({
                    failed: true
                })
            }
		}
	}

	render() {
		let content = (
			<div className="loading-overlay">
				<div className="relative">
					<SpinnerTimeLoader />
				</div>
			</div>
		);
		// if (this.state.error) {
		// 	content = <Message message={this.state.errorCode} action={Flow.goTo} />;
		// }

		if (this.state.success) {
			content = <TopUpSuccess />;
		}
		if (this.state.failed) {
			content = <TopUpFailed />;
		}


		return content;
	}
}